import "../../FhDivider.css";
import { computed, openBlock, createElementBlock, normalizeClass } from "vue";
import { VARIANTS_ENUMS } from "./constants.mjs";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-1tPrXgE0.js";
const _sfc_main = {
  __name: "FhDivider",
  props: {
    variant: {
      type: String,
      default: VARIANTS_ENUMS.DEFAULT,
      validator: (value) => Object.values(VARIANTS_ENUMS).includes(value)
    }
  },
  setup(__props) {
    const props = __props;
    const computedClasses = computed(() => {
      return ["fh-divider", `fh-divider--${props.variant}`];
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("hr", {
        class: normalizeClass(computedClasses.value),
        role: "separator"
      }, null, 2);
    };
  }
};
const FhDivider = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-35292896"]]);
export {
  FhDivider as default
};
//# sourceMappingURL=FhDivider.mjs.map
